import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { MatCardModule } from '@angular/material/card';

@Component({
    selector: 'app-privacy',
    imports: [CommonModule, RouterModule, MatCardModule],
    templateUrl: './privacy.component.html',
    styleUrls: ['./privacy.component.scss']
})
export class PrivacyComponent {
  constructor(private router: Router) {}

  // Privacy policy content
  showLoginFormOnHome() {
    console.log('Login form requested from navbar - navigating to home with login');
    this.router.navigate(['/'], { queryParams: { showLogin: 'true' } });
  }

  showTripSearchForm() {
    console.log('Trip search form requested from navbar - navigating to home');
    this.router.navigate(['/']);
  }
} 